import Vue from 'vue'
import VueRouter from 'vue-router'

import NProgress from 'nprogress'

import 'nprogress/nprogress.css'
import Mobile from '../views/Mobile'
import Web from '../views/Web'

import MoreMobile from '../views/MobileMore'
import MoreWeb from '../views/WebMore'

let view = Mobile;

if (window.innerWidth > 1160) {
    view = Web;
}

let Moreview = MoreMobile;

if (window.innerWidth > 1160) {
    Moreview = MoreWeb;
}

Vue.use(VueRouter)

let router = new VueRouter({
    routes: [
        {
            path: '/',
            name: 'home',
            component: view
        },
        {
            path: '/more',
            name: 'more',
            component: Moreview
        }
    ]
})

router.beforeEach((to, from, next) => {
    NProgress.start()
    next()
})

router.afterEach(() => {
    NProgress.done()
})

export default router = router;